import { SxProps, Theme } from '@mui/material';

export const filterContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const filterHeaderStyles: SxProps<Theme> = {
  flexDirection: 'row',
  gap: 1,
};

export const autocompleteStyles: SxProps<Theme> = {
  '.MuiInputBase-root': {
    backgroundColor: (theme) => theme.palette.grey[800],
    color: (theme) => theme.palette.common.white,
  },
};

export const chipStyles: SxProps<Theme> = {
  borderRadius: 2,
  color: (theme) => theme.palette.primary.contrastText,
  fontSize: (theme) => theme.typography.body2.fontSize,
  backgroundColor: (theme) => theme.palette.grey[900],
  padding: (theme) => theme.spacing(0.5, 1),
  display: 'flex',
  alignItems: 'center',
  '& .MuiSvgIcon-root': {
    color: (theme) => theme.palette.grey[400],
    '&:hover': {
      color: (theme) => theme.palette.grey[300],
    },
  },
  '& .MuiChip-avatar': {
    width: 1.5,
    height: 1.5,
  },
};

export const avatarStyles: SxProps<Theme> = {
  width: 1,
  height: 1,
  borderRadius: '50%',
  padding: 0.5,
};
